import ChallengesFormContainer from './challenges_form_container';

const ChallengesForm = ChallengesFormContainer;
export default ChallengesForm;
